export default "__VITE_ASSET__ff608b89__"